export const FILE_TYPE_STYLES = {
  pdf: 'bg-red-600',
  doc: 'bg-blue-600',
  excel: 'bg-green-600',
  image: 'bg-purple-600',
  video: 'bg-pink-600',
  audio: 'bg-orange-600',
  archive: 'bg-yellow-600',
  code: 'bg-gray-600',
  default: 'bg-slate-600',
};
